import { render } from "./FooterHome.vue?vue&type=template&id=4e988734&scoped=true"
import script from "./FooterHome.vue?vue&type=script&lang=js"
export * from "./FooterHome.vue?vue&type=script&lang=js"

import "./FooterHome.vue?vue&type=style&index=0&id=4e988734&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e988734"

export default script